export const ORDERPATTERN_GET_LIST = "/orderPattern";